import React from "react";
import { List, Expand, Info } from "lucide-react";
import clsx from "clsx";
import { useValidationContext } from "../../context";
import { useSearchParams } from "react-router-dom";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@shared/ui/tooltip";
export const ViewToggle: React.FC = () => {
  const { viewMode, setViewMode } = useValidationContext();
  const [searchParams, setSearchParams] = useSearchParams();

  const handleToggle = (view: "list" | "detail") => {
    if (view === "list") {
      const updatedParams = new URLSearchParams(searchParams); // safer clone
      // updatedParams.delete("readingId");
      setSearchParams(updatedParams);
    }
    setViewMode(view);
  };

  return (
    <div className="inline-flex rounded-md border border-gray-300 overflow-hidden">
      <button
        onClick={() => handleToggle("list")}
        className={clsx(
          "flex items-center gap-2 px-4 py-2 text-sm font-medium transition-colors",
          viewMode === "list"
            ? "bg-white text-cyan-600"
            : "bg-gray-100 text-gray-500"
        )}
      >
        <List className="h-4 w-4" />
        List View
      </button>
      {/* <button
        onClick={() => handleToggle("detail")}
        className={clsx(
          "flex items-center gap-2 px-4 py-2 text-sm font-medium transition-colors",
          viewMode === "detail"
            ? "bg-white text-cyan-600"
            : "bg-gray-100 text-gray-500"
        )}
      >
        <Expand className="h-4 w-4" />
        Detail View
      </button> */}
      <button
        onClick={() => handleToggle("detail")}
        className={clsx(
          "flex items-center gap-2 px-4 py-2 text-sm font-medium transition-colors",
          viewMode === "detail"
            ? "bg-white text-cyan-600"
            : "bg-gray-100 text-gray-500"
        )}
      >
        <Expand className="h-4 w-4" />
        Detail View
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Info className="h-4 w-4 text-gray-400 cursor-pointer" />
            </TooltipTrigger>
            <TooltipContent>
              <p>Assign Validator to view details</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </button>
    </div>
  );
};
